import React from 'react';
import './Reviews.css';
import { useLanguage } from './LanguageContext';

function Reviews() {
  const { language, translations } = useLanguage();

  return (
    // Hasta Yorumları bölümünün ana konteyneri
    <div className="reviews-section">
      <div className="section-container">
        {/* Başlık ve alt başlık artık dil dosyasından geliyor */}
        <h1 data-subtitle={translations[language].reviewsSubtitle}>
          {translations[language].reviewsTitle}
        </h1>

        {/* Elfsight widget'ı bu div'in içine yerleşecek */}
        
        
<script src="https://elfsightcdn.com/platform.js" async></script>
<div class="elfsight-app-2771b50e-ed83-4f5f-b6d4-53df7b95edff" data-elfsight-app-lazy></div>
      </div>
    </div>
  );
}

export default Reviews;
